import React from 'react'
import {
  EnglishLevelWrapper,
  EnglishLevelText,
  EnglishLevelSubText
} from './EnglishLevelItem.styles'
import activateOnEnterOrSpace from 'utils/activate-on-enter-or-space'

const EnglishLevelItem: React.FC<{
  level: string
  subText?: string
  onClick: () => void
  isCEFR?: boolean
  selected?: boolean
}> = ({ level, subText, onClick, isCEFR, selected }) => {
  return (
    <EnglishLevelWrapper
      data-testid="english-level"
      role="button"
      tabIndex={0}
      onKeyDown={activateOnEnterOrSpace(onClick)}
      onClick={onClick}
      isCEFR={isCEFR}
      selected={selected}
    >
      <EnglishLevelText isCEFR={isCEFR}>{level}</EnglishLevelText>
      {subText && <EnglishLevelSubText>{subText}</EnglishLevelSubText>}
    </EnglishLevelWrapper>
  )
}

export default EnglishLevelItem
